module.exports = __webpack_public_path__ + "static/media/bjarnii.caaf693e.svg";